module.exports = __webpack_public_path__ + "static/img/menu.359fa701.png";